import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const FileInputComponent = ({ fileInput = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);

  const isHovered = fileInput.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = fileInput;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = fileInput;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = fileInput;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = fileInput;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = fileInput;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        fileInput.backgroundImage &&
        fileInput.backgroundImage.startsWith("./")
      ) {
        const imageName = fileInput.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(fileInput.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [fileInput.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        fileInput.labelbackgroundImagelabel &&
        fileInput.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = fileInput.labelbackgroundImagelabel.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(fileInput.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [fileInput.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && fileInput.pseudoClass === "focus"
      ? {
          width: fileInput.focusedwidth || fileInput.width || "fit-content",
          height: fileInput.focusedheight || fileInput.height || "auto",

          padding: fileInput.focusedpadding || fileInput.padding || "0",
          paddingTop:
            fileInput.focusedpaddingTop || fileInput.focusedpadding || "0",
          paddingRight:
            fileInput.focusedpaddingRight || fileInput.focusedpadding || "3px",
          paddingBottom:
            fileInput.focusedpaddingBottom || fileInput.focusedpadding || "0",
          paddingLeft:
            fileInput.focusedpaddingLeft || fileInput.focusedpadding || "3px",
          margin: fileInput.focusedmargin || fileInput.margin || "0px",
          marginTop:
            fileInput.focusedmarginTop || fileInput.focusedmargin || "0px",
          marginRight:
            fileInput.focusedmarginRight || fileInput.focusedmargin || "0px",
          marginBottom:
            fileInput.focusedmarginBottom || fileInput.focusedmargin || "0px",
          marginLeft:
            fileInput.focusedmarginLeft || fileInput.focusedmargin || "10px",

          borderTop:
            fileInput.focusedborderTop ||
            fileInput.focusedborder ||
            fileInput.border ||
            "none",
          borderRight:
            fileInput.focusedborderRight ||
            fileInput.focusedborder ||
            fileInput.border ||
            "none",
          borderBottom:
            fileInput.focusedborderBottom ||
            fileInput.focusedborder ||
            fileInput.border ||
            "none",
          borderLeft:
            fileInput.focusedborderLeft ||
            fileInput.focusedborder ||
            fileInput.border ||
            "none",
          borderSapcing:
            fileInput.focusedborderSpacing || fileInput.borderSpacing || "0px",
          borderCollapse:
            fileInput.focusedborderCollapse ||
            fileInput.borderCollapse ||
            "0px",
          borderRadius:
            fileInput.focusedborderRadius || fileInput.borderRadius || "0",
          outline: fileInput.focusedoutline || fileInput.outline || "none",

          position:
            fileInput.focusedposition || fileInput.position || "relative",
          top: fileInput.focusedtop || fileInput.top || "auto",
          right: fileInput.focusedright || fileInput.right || "auto",
          bottom: fileInput.focusedbottom || fileInput.bottom || "auto",
          left: fileInput.focusedleft || fileInput.left || "auto",
          zIndex: fileInput.focusedzIndex || fileInput.zIndex || "auto",

          color: fileInput.focusedcolor || fileInput.color || "#000000",
          backgroundColor:
            fileInput.focusedbackgroundColor ||
            fileInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (fileInput.focusedbackgroundImage) {
              if (fileInput.focusedbackgroundImage.startsWith("./")) {
                const imageName = fileInput.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.focusedbackgroundImage})`;
            }
            if (fileInput.backgroundImage) {
              if (fileInput.backgroundImage.startsWith("./")) {
                const imageName = fileInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            fileInput.focusedbackgroundPosition ||
            fileInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            fileInput.focusedbackgroundSize ||
            fileInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            fileInput.focusedbackgroundRepeat ||
            fileInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            fileInput.focusedbackgroundAttachment ||
            fileInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            fileInput.focusedboxShadow || fileInput.boxShadow || "none",
          opacity: fileInput.focusedOpacity || fileInput.opacity || 1,
          display: fileInput.focuseddisplay || fileInput.display || "inline",

          fontFamily:
            fileInput.focusedfontFamily || fileInput.fontFamily || "inherit",
          fontSize:
            fileInput.focusedfontSize || fileInput.fontSize || "inherit",
          fontWeight:
            fileInput.focusedfontWeight || fileInput.fontWeight || "normal",
          fontStyle:
            fileInput.focusedfontStyle || fileInput.fontStyle || "normal",
          fontVariant:
            fileInput.focusedfontVariant || fileInput.fontVariant || "normal",
          lineHeight:
            fileInput.focusedlineHeight || fileInput.lineHeight || "normal",
          textShadow:
            fileInput.focusedtextShadow || fileInput.textShadow || "none",
          textAlign:
            fileInput.focusedtextAlign || fileInput.textAlign || "left",
          verticalAlign:
            fileInput.focusedverticalAlign ||
            fileInput.verticalAlign ||
            "baseline",
          textDecoration:
            fileInput.focusedtextDecoration ||
            fileInput.textDecoration ||
            "none",
          textTransform:
            fileInput.focusedtextTransform || fileInput.textTransform || "none",
          letterSpacing:
            fileInput.focusedletterSpacing ||
            fileInput.letterSpacing ||
            "normal",
          wordSpacing:
            fileInput.focusedwordSpacing || fileInput.wordSpacing || "normal",
          textIndent:
            fileInput.focusedtextIndent || fileInput.textIndent || "0",
          whiteSpace:
            fileInput.focusedwhiteSpace || fileInput.whiteSpace || "normal",
          textOverflow:
            fileInput.focusedtextOverflow || fileInput.textOverflow || "clip",
          direction: fileInput.focuseddirection || fileInput.direction || "ltr",
          unicodeBidi:
            fileInput.focusedunicodeBidi || fileInput.unicodeBidi || "normal",
          writingMode:
            fileInput.focusedwritingMode ||
            fileInput.writingMode ||
            "horizontal-tb",

          cursor: fileInput.focusedcursor || fileInput.cursor || "default",
          transform:
            fileInput.focusedtransform || fileInput.transform || "none",
          transition:
            fileInput.focusedtransition || fileInput.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && fileInput.pseudoClass === "hover"
      ? {
          width: fileInput.hoveredwidth || fileInput.width || "fit-content",
          height: fileInput.hoveredheight || fileInput.height || "auto",

          padding: fileInput.hoveredpadding || fileInput.padding || "0",
          paddingTop:
            fileInput.hoveredpaddingTop || fileInput.hoveredpadding || "0",
          paddingRight:
            fileInput.hoveredpaddingRight || fileInput.hoveredpadding || "3px",
          paddingBottom:
            fileInput.hoveredpaddingBottom || fileInput.hoveredpadding || "0",
          paddingLeft:
            fileInput.hoveredpaddingLeft || fileInput.hoveredpadding || "3px",
          margin: fileInput.hoveredmargin || fileInput.margin || "0px",
          marginTop:
            fileInput.hoveredmarginTop || fileInput.hoveredmargin || "0px",
          marginRight:
            fileInput.hoveredmarginRight || fileInput.hoveredmargin || "0px",
          marginBottom:
            fileInput.hoveredmarginBottom || fileInput.hoveredmargin || "0px",
          marginLeft:
            fileInput.hoveredmarginLeft || fileInput.hoveredmargin || "10px",

          borderTop:
            fileInput.hoveredborderTop ||
            fileInput.hoveredborder ||
            fileInput.border ||
            "none",
          borderRight:
            fileInput.hoveredborderRight ||
            fileInput.hoveredborder ||
            fileInput.border ||
            "none",
          borderBottom:
            fileInput.hoveredborderBottom ||
            fileInput.hoveredborder ||
            fileInput.border ||
            "none",
          borderLeft:
            fileInput.hoveredborderLeft ||
            fileInput.hoveredborder ||
            fileInput.border ||
            "none",
          borderSapcing:
            fileInput.hoveredborderSpacing || fileInput.borderSpacing || "0px",
          borderCollapse:
            fileInput.hoveredborderCollapse ||
            fileInput.borderCollapse ||
            "0px",
          borderRadius:
            fileInput.hoveredborderRadius || fileInput.borderRadius || "0",
          outline: fileInput.hoveredoutline || fileInput.outline || "none",

          position:
            fileInput.hoveredposition || fileInput.position || "relative",
          top: fileInput.hoveredtop || fileInput.top || "auto",
          right: fileInput.hoveredright || fileInput.right || "auto",
          bottom: fileInput.hoveredbottom || fileInput.bottom || "auto",
          left: fileInput.hoveredleft || fileInput.left || "auto",
          zIndex: fileInput.hoveredzIndex || fileInput.zIndex || "auto",

          color: fileInput.hoveredcolor || fileInput.color || "#000000",
          backgroundColor:
            fileInput.hoveredbackgroundColor ||
            fileInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (fileInput.hoveredbackgroundImage) {
              if (fileInput.hoveredbackgroundImage.startsWith("./")) {
                const imageName = fileInput.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.hoveredbackgroundImage})`;
            }
            if (fileInput.backgroundImage) {
              if (fileInput.backgroundImage.startsWith("./")) {
                const imageName = fileInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            fileInput.hoveredbackgroundPosition ||
            fileInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            fileInput.hoveredbackgroundSize ||
            fileInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            fileInput.hoveredbackgroundRepeat ||
            fileInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            fileInput.hoveredbackgroundAttachment ||
            fileInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            fileInput.hoveredboxShadow || fileInput.boxShadow || "none",
          opacity: fileInput.hoveredOpacity || fileInput.opacity || 1,
          display: fileInput.hovereddisplay || fileInput.display || "inline",

          fontFamily:
            fileInput.hoveredfontFamily || fileInput.fontFamily || "inherit",
          fontSize:
            fileInput.hoveredfontSize || fileInput.fontSize || "inherit",
          fontWeight:
            fileInput.hoveredfontWeight || fileInput.fontWeight || "normal",
          fontStyle:
            fileInput.hoveredfontStyle || fileInput.fontStyle || "normal",
          fontVariant:
            fileInput.hoveredfontVariant || fileInput.fontVariant || "normal",
          lineHeight:
            fileInput.hoveredlineHeight || fileInput.lineHeight || "normal",
          textShadow:
            fileInput.hoveredtextShadow || fileInput.textShadow || "none",
          textAlign:
            fileInput.hoveredtextAlign || fileInput.textAlign || "left",
          verticalAlign:
            fileInput.hoveredverticalAlign ||
            fileInput.verticalAlign ||
            "baseline",
          textDecoration:
            fileInput.hoveredtextDecoration ||
            fileInput.textDecoration ||
            "none",
          textTransform:
            fileInput.hoveredtextTransform || fileInput.textTransform || "none",
          letterSpacing:
            fileInput.hoveredletterSpacing ||
            fileInput.letterSpacing ||
            "normal",
          wordSpacing:
            fileInput.hoveredwordSpacing || fileInput.wordSpacing || "normal",
          textIndent:
            fileInput.hoveredtextIndent || fileInput.textIndent || "0",
          whiteSpace:
            fileInput.hoveredwhiteSpace || fileInput.whiteSpace || "normal",
          textOverflow:
            fileInput.hoveredtextOverflow || fileInput.textOverflow || "clip",
          direction: fileInput.hovereddirection || fileInput.direction || "ltr",
          unicodeBidi:
            fileInput.hoveredunicodeBidi || fileInput.unicodeBidi || "normal",
          writingMode:
            fileInput.hoveredwritingMode ||
            fileInput.writingMode ||
            "horizontal-tb",

          cursor: fileInput.hoveredcursor || fileInput.cursor || "default",
          transform:
            fileInput.hoveredtransform || fileInput.transform || "none",
          transition:
            fileInput.hoveredtransition || fileInput.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && fileInput.pseudoClass === "active"
      ? {
          width: fileInput.activatedwidth || fileInput.width || "fit-content",
          height: fileInput.activatedheight || fileInput.height || "auto",

          padding: fileInput.activatedpadding || fileInput.padding || "0",
          paddingTop:
            fileInput.activatedpaddingTop || fileInput.activatedpadding || "0",
          paddingRight:
            fileInput.activatedpaddingRight ||
            fileInput.activatedpadding ||
            "3px",
          paddingBottom:
            fileInput.activatedpaddingBottom ||
            fileInput.activatedpadding ||
            "0",
          paddingLeft:
            fileInput.activatedpaddingLeft ||
            fileInput.activatedpadding ||
            "3px",
          margin: fileInput.activatedmargin || fileInput.margin || "0px",
          marginTop:
            fileInput.activatedmarginTop || fileInput.activatedmargin || "0px",
          marginRight:
            fileInput.activatedmarginRight ||
            fileInput.activatedmargin ||
            "0px",
          marginBottom:
            fileInput.activatedmarginBottom ||
            fileInput.activatedmargin ||
            "0px",
          marginLeft:
            fileInput.activatedmarginLeft ||
            fileInput.activatedmargin ||
            "10px",

          borderTop:
            fileInput.activatedborderTop ||
            fileInput.activatedborder ||
            fileInput.border ||
            "none",
          borderRight:
            fileInput.activatedborderRight ||
            fileInput.activatedborder ||
            fileInput.border ||
            "none",
          borderBottom:
            fileInput.activatedborderBottom ||
            fileInput.activatedborder ||
            fileInput.border ||
            "none",
          borderLeft:
            fileInput.activatedborderLeft ||
            fileInput.activatedborder ||
            fileInput.border ||
            "none",
          borderSapcing:
            fileInput.activatedborderSpacing ||
            fileInput.borderSpacing ||
            "0px",
          borderCollapse:
            fileInput.activatedborderCollapse ||
            fileInput.borderCollapse ||
            "0px",
          borderRadius:
            fileInput.activatedborderRadius || fileInput.borderRadius || "0",
          outline: fileInput.activatedoutline || fileInput.outline || "none",

          position:
            fileInput.activatedposition || fileInput.position || "relative",
          top: fileInput.activatedtop || fileInput.top || "auto",
          right: fileInput.activatedright || fileInput.right || "auto",
          bottom: fileInput.activatedbottom || fileInput.bottom || "auto",
          left: fileInput.activatedleft || fileInput.left || "auto",
          zIndex: fileInput.activatedzIndex || fileInput.zIndex || "auto",

          color: fileInput.activatedcolor || fileInput.color || "#000000",
          backgroundColor:
            fileInput.activatedbackgroundColor ||
            fileInput.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (fileInput.activatedbackgroundImage) {
              if (fileInput.activatedbackgroundImage.startsWith("./")) {
                const imageName = fileInput.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.activatedbackgroundImage})`;
            }
            if (fileInput.backgroundImage) {
              if (fileInput.backgroundImage.startsWith("./")) {
                const imageName = fileInput.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${fileInput.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            fileInput.activatedbackgroundPosition ||
            fileInput.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            fileInput.activatedbackgroundSize ||
            fileInput.backgroundSize ||
            "auto",
          backgroundRepeat:
            fileInput.activatedbackgroundRepeat ||
            fileInput.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            fileInput.activatedbackgroundAttachment ||
            fileInput.backgroundAttachment ||
            "scroll",

          boxShadow:
            fileInput.activatedboxShadow || fileInput.boxShadow || "none",
          opacity: fileInput.activatedOpacity || fileInput.opacity || 1,
          display: fileInput.activateddisplay || fileInput.display || "inline",

          cursor: fileInput.activatedcursor || fileInput.cursor || "default",
          transform:
            fileInput.activatedtransform || fileInput.transform || "none",
          transition:
            fileInput.activatedtransition || fileInput.transition || "none",
        }
      : {};

  const inputStyle = {
    width: fileInput.width || "fit-content",
    height: fileInput.height || "auto",

    margin: fileInput.margin || "0px",
    marginTop: fileInput.marginTop || fileInput.margin || "0",
    marginRight: fileInput.marginRight || fileInput.margin || "0px",
    marginBottom: fileInput.marginBottom || fileInput.margin || "0",
    marginLeft: fileInput.marginLeft || fileInput.margin || "10px",
    padding: fileInput.padding || "0px",
    paddingTop: fileInput.paddingTop || fileInput.padding || "0",
    paddingRight: fileInput.paddingRight || fileInput.padding || "3px",
    paddingBottom: fileInput.paddingBottom || fileInput.padding || "0",
    paddingLeft: fileInput.paddingLeft || fileInput.padding || "3px",

    borderTop: isHovered
      ? "1px dashed #555"
      : fileInput.borderTop || fileInput.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : fileInput.borderRight || fileInput.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : fileInput.borderBottom || fileInput.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : fileInput.borderLeft || fileInput.border || "none",

    borderSapcing: fileInput.borderSpacing || "0px",
    borderCollapse: fileInput.borderCollapse || "0px",
    borderRadius: fileInput.borderRadius || "0",
    outline: fileInput.outline || "none",

    position: fileInput.position || "static",
    top: fileInput.top || "auto",
    right: fileInput.right || "auto",
    bottom: fileInput.bottom || "auto",
    left: fileInput.left || "auto",
    zIndex: fileInput.zIndex || "auto",

    color: fileInput.color || "#000000",
    backgroundColor: fileInput.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      fileInput.focusedbackgroundPosition ||
      fileInput.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      fileInput.focusedbackgroundSize || fileInput.backgroundSize || "auto",
    backgroundRepeat:
      fileInput.focusedbackgroundRepeat ||
      fileInput.backgroundRepeat ||
      "repeat",
    backgroundAttachment:
      fileInput.focusedbackgroundAttachment ||
      fileInput.backgroundAttachment ||
      "scroll",

    fontSize: fileInput.fontSize || "inherit",
    fontFamily: fileInput.fontFamily || "inherit",
    fontWeight: fileInput.fontWeight || "normal",
    fontStyle: fileInput.fontStyle || "normal",
    fontVariant: fileInput.fontVariant || "normal",
    lineHeight: fileInput.lineHeight || "normal",
    textAlign: fileInput.textAlign || "left",
    textDecoration: fileInput.textDecoration || "none",
    textTransform: fileInput.textTransform || "none",
    textShadow: fileInput.textShadow || "none",
    verticalAlign: fileInput.verticalAlign || "baseline",
    letterSpacing: fileInput.letterSpacing || "normal",
    wordSpacing: fileInput.wordSpacing || "normal",
    textIndent: fileInput.textIndent || "0",
    whiteSpace: fileInput.whiteSpace || "normal",
    textOverflow: fileInput.textOverflow || "clip",
    direction: fileInput.direction || "ltr",
    unicodeBidi: fileInput.unicodeBidi || "normal",
    writingMode: fileInput.writingMode || "horizontal-tb",

    opacity: fileInput.opacity || "1",
    display: fileInput.display || "inline",
    cursor: fileInput.cursor || "auto",

    transform: fileInput.transform || "none",
    transition: fileInput.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: fileInput.labelmargin || "0px",
    marginTop: fileInput.labelmarginTop || fileInput.labelmargin || "0",
    marginRight: fileInput.labelmarginRight || fileInput.labelmargin || "0px",
    marginBottom: fileInput.labelmarginBottom || fileInput.labelmargin || "0",
    marginLeft: fileInput.labelmarginLeft || fileInput.labelmargin || "0",
    padding: fileInput.labelpadding || "0px",
    paddingTop: fileInput.labelpaddingTop || fileInput.labelpadding || "0",
    paddingRight: fileInput.labelpaddingRight || fileInput.labelpadding || "0",
    paddingBottom:
      fileInput.labelpaddingBottom || fileInput.labelpadding || "0",
    paddingLeft: fileInput.labelpaddingLeft || fileInput.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : fileInput.labelborderTop || fileInput.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : fileInput.labelborderRight || fileInput.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : fileInput.labelborderBottom || fileInput.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : fileInput.labelborderLeft || fileInput.labelborder || "none",

    borderSapcing: fileInput.labelborderSpacing || "0px",
    borderCollapse: fileInput.labelborderCollapse || "0px",
    borderRadius: fileInput.labelborderRadius || "0",
    outline: fileInput.labeloutline || "none",

    position: fileInput.labelposition || "static",
    top: fileInput.labeltop || "auto",
    right: fileInput.labelright || "auto",
    bottom: fileInput.labelbottom || "auto",
    left: fileInput.labelleft || "auto",
    zIndex: fileInput.labelzIndex || "auto",

    color: fileInput.labelcolor || "#000000",
    backgroundColor: fileInput.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      fileInput.labelbackgroundPosition ||
      fileInput.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      fileInput.labelbackgroundSize || fileInput.labelbackgroundSize || "auto",
    backgroundRepeat:
      fileInput.labelbackgroundRepeat ||
      fileInput.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      fileInput.labelbackgroundAttachment ||
      fileInput.labelbackgroundAttachment ||
      "scroll",

    opacity: fileInput.labelopacity || "1",
    display: fileInput.display || "inline",
    cursor: fileInput.cursor || "auto",

    transform: fileInput.transform || "none",
    transition: fileInput.transition || "none",
  };

  return (
    <>
      <label style={labelStyle}>{fileInput.label || "File Input"}</label>

      <input
        type="file"
        placeholder={fileInput.placeholder || "Select a file"}
        style={inputStyle}
        accept={fileInput.accept}
        multiple={fileInput.multiple || false}
        disabled={fileInput.disabled || false}
        required={fileInput.required || false}
        capture={fileInput.capture}
        directory={fileInput.directory ? "true" : undefined}
        webkitdirectory={fileInput.webkitdirectory ? "true" : undefined}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
      />
    </>
  );
};

export default FileInputComponent;
